import { Query } from '../Model/Query';
import { Third } from '../Model/Third';
export class ThirdsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(thirdId) {
        if (thirdId) {
            const response = await this.apiService.get('third/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener el tercero.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ThirdId.`);
        }
    }
    async findThirds(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`thirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveThird(third) {
        if (third) {
            const response = await this.apiService.post('third', third instanceof Third ? third.getState() : third);
            if (!response.ok) {
                throw new Error(`Error al guardar el tercero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async getQuantity(opts) {
        var _a;
        const query = new Query();
        if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
            query.addFilter('search', [opts.filters.search]);
        }
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`thirds_quantity?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener los terceros.`);
        }
        const content = await response.json();
        return parseInt(content);
    }
}
